import dayjs from 'dayjs'
import { JaasWebApi } from '@/api/jaasweb'
import tool from '@/utils/tool'

export default {
  data() {
    return {
      isEvaluate: false
    }
  },
  methods: {
    ...tool,
    // 评价
    evaluate(item) {
      this.isEvaluate = false
      if (!this.getCookie('accessToken')) {
        this.$message.warning({
          message: '登录信息失效，请重新登录！',
          center: true
        })
      }
      window.evaluate(
        // 评价参数
        {
          params: {
            title: '评价',
            taskCode: '123',
            userProp: this.$store.state.userInfo.encodeUser?.userType,
            taskHandleItem: '',
            taskName: item.applyname, // 事项名称
            projectNo: item.applyno,
            taskcode: '123',
            areaCode: item.districtid, // 区划id
            pf: '1', // 1
            proDepart: item.groupName, // 事项部门
            applicationName: '一网通办政务服务网', // 应用名称
            proStatus: '3',
            uuid: this.getCookie('accessToken')
          }
        },
        () => {
          this.updataState(item.iid)
        }
      )
    },

    // 去登录
    toLogin() {
      // 跳转到jis登录地址
      window.open(`/jis-web/login?redirectUrl=${encodeURIComponent(window.location.href)}`, '_self')
    },

    // 更新评价状态
    updataState(itemId) {
      JaasWebApi.modifyReviewState({ applyId: itemId }).then(() => {
        this.isEvaluate = true
        if (this.$route.name === 'appointment-detail') {
          this.getApplyDetail()
        }
      })
    },

    // 文件下载
    download(fileUrl, fileName, appId) {
      let localUrl
      if (process.env.NODE_ENV === 'development') {
        localUrl = ''
      } else {
        localUrl = window.location.origin
      }
      const url = `${localUrl}/api-gateway/jpaas-jaas-web-server/interface/business/download-file?url=${fileUrl}&name=${fileName}&userId=${this.$store.state.userInfo.encodeUser.uid}&appId=${appId}`
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
    },

    // 判断是否可以入会
    judgeEnterMeetingTime(givenTime, meetingType) {
      // 给定时间字符串
      let startTime
      if (meetingType === 'imme') {
        startTime = givenTime
      } else {
        startTime = this.splitStartTime(givenTime)
      }

      // 将给定时间转换为Day.js对象
      const compareTime = dayjs(startTime)
      let diffMinutes

      // 计算与当前时间的差值（单位：分钟）
      try {
        diffMinutes = compareTime.diff(dayjs(), 'minutes')
      } catch (error) {
        return false
      }

      // 判断差值是否小于5分钟
      return diffMinutes < 5
    },

    // 时间区间截取开始时间
    splitStartTime(timeSpace) {
      const startTime = `${timeSpace.split(' ')[0]} ${timeSpace.split(' ')[1].split('-')[0]}`
      return startTime
    },

    // 判断用户类型与事项服务对象是否匹配
    checkUserTypeAndIsLogin(userType) {
      if (!this.userInfo.isLogin) {
        // 需要登录且获取不到用户信息，弹窗提示
        this.$confirm('您还未登录，是否前往登录', '提示')
          .then(() => {
            // 用户点击了确定按钮
            this.toLogin()
          })
          .catch(() => {
            // 用户点击了取消按钮
          })
        return false
      }
      if (userType !== this.userInfo?.encodeUser?.userType) {
        const Type = userType === 1 ? '个人' : '法人'
        const tips = `当前事项服务对象为${Type}，请切换${Type}账号后再试`
        this.$alert(tips, '提示')
        return false
      }
      return true
    }
  }
}
